import { render, staticRenderFns } from "./SidebarSkema.vue?vue&type=template&id=34165b8a&"
import script from "./SidebarSkema.vue?vue&type=script&lang=js&"
export * from "./SidebarSkema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports